import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen } from 'lucide-react';
interface DiaryEntryProps {
  title: string;
  date: string;
  text: ReactNode;
  image?: string;
  delay?: number;
}
export function DiaryEntry({
  title,
  date,
  text,
  image,
  delay = 0
}: DiaryEntryProps) {
  return <motion.article initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.6,
    delay
  }} className="w-full max-w-3xl mx-auto mb-12 bg-cream-dark p-6 md:p-10 rounded-xl border border-brown-light/40 shadow-sm relative" data-id="element-62">
      <div className="absolute top-6 right-6 text-brown-light/30" data-id="element-63">
        <BookOpen size={24} data-id="element-64" />
      </div>

      <div className="mb-6" data-id="element-65">
        <span className="font-handwriting text-2xl text-forest block mb-1" data-id="element-66">
          {date}
        </span>
        <h3 className="font-serif text-2xl md:text-3xl font-semibold text-brown-dark" data-id="element-67">
          {title}
        </h3>
      </div>

      <div className="prose prose-lg prose-stone max-w-none" data-id="element-68">
        <p className="font-serif text-lg leading-relaxed text-brown-dark/90 whitespace-pre-line" data-id="element-69">
          {text}
        </p>
      </div>

      {image && <div className="mt-8 rounded-lg overflow-hidden border-2 border-white shadow-md transform -rotate-1" data-id="element-70">
          <img src={image} alt="Tagebuch Foto" className="w-full h-auto object-cover" data-id="element-71" />
        </div>}
    </motion.article>;
}